import {pickAll} from 'ramda'

const configKeys: readonly string[] = [
  'REACT_APP_SENTRY_DSN',
  'REACT_APP_SAPI_PROFILE_KEY',
  'REACT_APP_ALGOLIA_APP_ID',
  'REACT_APP_ALGOLIA_API_KEY',
  'REACT_APP_ALGOLIA_INDEX_PREFIX',
  'REACT_APP_GTM_ID',
  'REACT_APP_ENABLED_CURRENCIES',
  'REACT_APP_VERSION',
  'REACT_APP_ENV',
  'REACT_APP_BOFH_ENDPOINT',
  'REACT_APP_SEARCH_ENDPOINT',
  'REACT_APP_ANALYTICS_API_KEY',
  'REACT_APP_ANALYTICS_ENDPOINT',
  'REACT_APP_ANALYTICS_DEFAULT_ENDPOINT',
  'REACT_APP_ANALYTICS_DEFAULT_API_KEY',
  'REACT_APP_ANALYTICS_RETENTION_ENDPOINT',
  'REACT_APP_ANALYTICS_RETENTION_API_KEY',
  'REACT_APP_USE_MOCKS',
  'REACT_APP_APP_ENVIRONMENT',
  'PUBLIC_URL',
  'REACT_APP_DD_CLIENT_TOKEN',
  'REACT_APP_RECAPTCHA_KEY',
  'REACT_APP_DD_RUM_APP_ID',
  'REACT_APP_DD_SAMPLE_RATE',
  'REACT_APP_DD_REPLAY_SAMPLE_RATE',
  'REACT_APP_RAA_KEY',
  'REACT_APP_RAA_ENDPOINT',
  'REACT_APP_RAA_POLLING_TIMEOUT',
  'REACT_APP_RAA_REQUEST_TIMEOUT',
  'REACT_APP_PROVIDER_LOGO_PREFIX',
  'REACT_APP_PCI_PROXY_MERCHANT_ID',
  'REACT_APP_PCI_PROXY_SCRIPT_SRC',
  'REACT_APP_PCI_PROXY_API_ENDPOINT',
  'REACT_APP_ANALYTICS_CUSTOMER_DATA_ENDPOINT',
  'REACT_APP_ANALYTICS_CUSTOMER_DATA_API_KEY',
  'REACT_APP_EPS_PROFILE_KEY',
  'REACT_APP_EPS_PSD2_IFRAME_URL',
  'REACT_APP_OPTIMIZELY_DATAFILE_URL',
  'REACT_APP_BOOKING_MANAGEMENT_ENVIRONMENT',
  'REACT_APP_STRIPE_API_KEY',
  'REACT_APP_GMAPS_API_KEY',
  'REACT_APP_RISKIFIED_SHOP_URL',
  'REACT_APP_SAPI_ENDPOINT',
  'REACT_APP_IMGPROXY_ENDPOINT_URL',
  'REACT_APP_IMGPROXY_ENDPOINT_SECRET',
  'REACT_APP_BOFH_PROFILE_KEY_ASSISTED_BOOKING',
  'REACT_APP_BOFH_PROFILE_KEY_ASSISTED_BOOKING_WITH_POST_STAY_NPS',
  'REACT_APP_BOFH_PROFILE_KEY_MOR',
  'REACT_APP_BOFH_PROFILE_KEY_MOR_WITH_POST_STAY_NPS',
  'WEBSITE_ENABLE_SIMULATOR',
  'REACT_APP_WHATSAPP_LINK',
  'REACT_APP_FACEBOOK_MESSENGER_LINK'
]

const _settings = Symbol('settingsKeys')

const Settings = function () {
  const configs = window._env || process.env
  this[_settings] = {}

  this[_settings] = pickAll(configKeys, configs)
  // TODO: Disabled for enforcing lint, fix if possible
  // eslint-disable-next-line no-undef
  const get = (key: configKeys): string => this[_settings][key]

  return {get}
}

export default new Settings()
